import { render, staticRenderFns } from "./custom-object-add-field.vue?vue&type=template&id=37602f16&scoped=true&"
import script from "./custom-object-add-field.js?vue&type=script&lang=js&"
export * from "./custom-object-add-field.js?vue&type=script&lang=js&"
import style0 from "./custom-object-add-field.scss?vue&type=style&index=0&id=37602f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37602f16",
  null
  
)

component.options.__file = "custom-object-add-field.vue"
export default component.exports